export default "__VITE_ASSET__C6TlGB4Q__"